var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgEditDisabled = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.6468 6.85536L17.1106 0.319194C16.6852 -0.106073 15.9956 -0.106073 15.5702 0.319194L0.319183 15.5703C0.114874 15.7745 6.16986e-05 16.0515 0 16.3404V22.8766C0 23.4782 0.487724 23.966 1.08936 23.966H7.62553C7.91443 23.9659 8.19146 23.8511 8.39571 23.6468L23.6468 8.39572C24.072 7.97033 24.072 7.28076 23.6468 6.85536ZM7.17454 21.7872H2.17872V16.7914L13.0723 5.89782L18.0682 10.8936L7.17454 21.7872ZM16.3404 2.62973L14.6127 4.35746L19.6085 9.35327L21.3362 7.62554L16.3404 2.62973Z",
    fill: "#D2D2D2"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEditDisabled);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/editDisabled.7f2143c787b5165caf5d1e1f9d51caea.svg";